import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { CheckOutline } from '@withjoy/joykit/icons';

interface FeatureProps
  extends Readonly<{
    feature: string;
  }> {}

export const Feature: React.FC<FeatureProps> = ({ feature }) => {
  return (
    <Flex
      alignItems="center"
      gap={3}
    >
      <Flex
        padding={2}
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
      >
        <CheckOutline
          size={24}
          color="mono14"
        />
      </Flex>
      <TextV2
        typographyVariant="body1"
        color="mono14"
      >
        {feature}
      </TextV2>
    </Flex>
  );
};
